module.exports = __webpack_public_path__ + "static/media/gorra (12).42fe111a.png";